// A busca estendida do Fuse.js dá significado especial a alguns caracteres
// (' = ! ^ $ |) — removidos aqui pra um usuário digitando um texto comum nunca
// acionar por acidente uma sintaxe de exclusão/match exato sem querer.
// Espelha backend/helpers/fiscal/sanitizeFuseQuery.js.
function sanitizeFuseQuery(q) {
    return (q || '').replace(/['^$!=|]/g, ' ').trim()
}

export default sanitizeFuseQuery
